/* eslint-disable react/prop-types */
import "./styles.css";
import React from "react";
import { FaUserAlt, FaIdCard } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";

// eslint-disable-next-line react/prop-types
const ListaClientes = ({ lista, maxHeight }) => {
  const navigate = useNavigate();
  const { setIDClienteAberto } = usePentagovContext();

  const handleCardClick = (id) => {
    setIDClienteAberto(id);
    navigate(`/Servicos/${id}`);
  };

  return (
    <div
      className="card-container"
      style={{
        maxHeight: maxHeight || "65vh",
        width: "98.5%",
        overflowY: "auto",
        padding: "10px",
      }}
    >
      {lista.map((cliente) => (
        <div
          key={cliente.IDCliente}
          className="card-cli"
          onClick={() => handleCardClick(cliente.IDCliente)}
        >
          <div className="card-content">
            <h3 style={{ width: "100%", textAlign: "start", paddingLeft: "5%" }}>
              <FaUserAlt style={{ marginRight: "8px" }} />
              {cliente.nome}
            </h3>
            <div className="row">
              <div
                className="col-sm-8"
                // eslint-disable-next-line react/no-unknown-property
                align="left"
                style={{ fontSize: "0.8em", paddingLeft: "5%" }}
              >
                <>
                  <FaIdCard style={{ marginRight: "8px", marginLeft: "15px" }} />
                  CNPJ: {cliente.cnpj}
                </>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListaClientes;
